<div class="container-fluid">

  <div>
    <div class="margin-top-8">
      <div class="header">
        {{
        !editingProduct ? ( 'bikeshop.pos_products.add_product' | translate ) : ( 'bikeshop.pos_products.edit_product' |
        translate
        )
        }}
      </div>
      <div class="product_description">
        {{ 'bikeshop.pos_products.description' | translate }}
      </div>

    </div>
    <div class="margin-top-8 info-container content">
      <p-progressSpinner *ngIf="loading" [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
        animationDuration=".5s"></p-progressSpinner>


      <div *ngIf="!loading">

        <div class="row margin-top-16" *ngIf="!isPOSSKU">
          <div class="col-md-4 label" [ngClass]="{'red bold': skuExists}">
            {{ 'bikeshop.products.sku' | translate }}
          </div>
          <div class="col-md-6 value">
            <input id="float-input" type="text" pInputText
              placeholder="{{ 'bikeshop.products.sku_placeholder' | translate }}" [(ngModel)]="product.sku"
              (ngModelChange)="product.sku = $event.toUpperCase()" (keydown)="inputChanged()"
              (focus)="editingSKU = true" (blur)="editingSKU = false" />
            <div class="small" *ngIf="skuExists">{{ 'bikeshop.products.sku_already_taken' | translate }}</div>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label" [ngClass]="{'red bold': !product.name}">
            {{ 'bikeshop.products.product_name' | translate }}
          </div>
          <div class="col-md-8 value">
            <input id="float-input" type="text" pInputText
              placeholder="{{ 'bikeshop.products.product_name' | translate }}" [(ngModel)]="product.name" />
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.brand' | translate }}
          </div>
          <div class="col-md-4 value">
            <input id="float-input" type="text" pInputText [(ngModel)]="product.brand" />
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.type' | translate }}
          </div>
          <div class="col-md-4 value">
            <input id="float-input" type="text" pInputText [(ngModel)]="product.type" />
          </div>
        </div>

        <hr />

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.manufacturer_sku' | translate }}
          </div>
          <div class="col-md-4 value">
            <input id="float-input" type="text" pInputText [(ngModel)]="product.manufacturerSKU" />
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.ean' | translate }}
          </div>
          <div class="col-md-4 value">
            <input id="float-input" type="text" pInputText [(ngModel)]="product.ean" />
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.upc' | translate }}
          </div>
          <div class="col-md-4 value">
            <input id="float-input" type="text" pInputText [(ngModel)]="product.upc" />
          </div>
        </div>

        <hr />

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.taxable' | translate }}
          </div>
          <div class="col-md-4 value">
            <p-inputSwitch [(ngModel)]="product.taxable"></p-inputSwitch>
          </div>
        </div>

        <div class="row margin-top-16" *ngIf="isPOSSKU">
          <div class="col-md-4 label">
            {{ 'bikeshop.inventory_audit.statuses.non_inventory_item' | translate }}
          </div>
          <div class="col-md-4 value">
            <p-inputSwitch [(ngModel)]="product.nonInventory"></p-inputSwitch>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label">
            {{ 'bikeshop.products.cost_price' | translate }}
          </div>
          <div class="col-md-3 value flex">
            <input currencyMask class="p-inputtext" [(ngModel)]="product.costPrice" [options]="currencyoptions" />
          </div>
          <div class="col-md-5 flex">
            <div>
              {{ (vatInclusive ? 'bikeshop.products.incl_vat' : 'bikeshop.products.excl_vat') | translate }}
            </div>
          </div>
        </div>

        <div class="row margin-top-16">
          <div class="col-md-4 label"
            [ngClass]="{'red bold': product.defaultPrice === null || product.defaultPrice === undefined || product.defaultPrice.length === 0 }">
            {{ 'bikeshop.products.default_price' | translate }}
          </div>
          <div class="col-md-3 value flex">
            <input currencyMask class="p-inputtext" [(ngModel)]="product.defaultPrice" [options]="currencyoptions" />
          </div>
          <div class="col-md-5 flex">
            <div>
              {{ (vatInclusive ? 'bikeshop.products.incl_vat' : 'bikeshop.products.excl_vat') | translate }}
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 8px">
          <div class="col-md-4 label">
          </div>
          <div class="col-md-8 flex">
            <small>
              ***{{ 'bikeshop.products.tax_explanation' | translate }}
            </small>
          </div>
        </div>

        <hr>

        <div class="row margin-top-16" *ngIf="!loading">
          <div class="col-md-4">
            <button *ngIf="product.id" pButton (click)="deleteProduct()" class="p-button-raised alternate full-width"
              label="{{'bikeshop.products.delete_product' | translate}}" [disabled]="saving || loading"></button>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <button pButton (click)="save()" class="p-button-raised full-width"
              label="{{'bikeshop.general.save' | translate}}"
              [disabled]="saving || loading || !valid() || editingSKU"></button>
          </div>

        </div>
      </div>



    </div>
  </div>
  <p-confirmDialog key="add_edit_products"></p-confirmDialog>